module.exports = __webpack_public_path__ + "media/img/wedding_success/tvw_logo-cf223abdb35dfb88ba9c7864080d9abd.png";